import type { TFunction } from 'i18next';
import type { ProductType } from '../../payment.types';

export const getThankYouButtonTitle = (productType: ProductType, t: TFunction) => {
  switch (productType) {
    case 'TreasuryProductBattlePass':
      return t('Begin pass');
    case 'TreasuryProductXPBooster':
      return t('Begin pass');
    default:
      return t('back to mobalytics!');
  }
};
